export default {
    StockRules: {
        Header: {
            title: '库存规则',
            method: '小数点计算方式',
            down: '向下取整会将小数全部舍去，例如：10.896，结果为10',
            up: '向上取整无论整数后面小数是多少都会舍去，并且整数+1，例如：12.321，结果为13',
            shortage: '缺货订单是否优先补货',
            channel: '设置渠道补货优先级',
            rule: '缺货订单优先分配规则',
            delivery: '按预计发货时间由近到远',
            quantity: '按缺货数量',
            quan: '从少到多',
            tity: '从多到少',
            priority: '设置优先级',
            methods: '渠道',
            priorit: '优先级',
        },
        Main: {
            title: '库存同步规则',
            Channel: '渠道同步优先级',
            Virtual: '虚仓同步优先规则',
            Drag: '拖动排序，越上面优先级越高',
            rule: '同类型虚仓同步优先规则',
            less: '按可用库存从少到多',
            creation: '按创建时间',
            near: '从近到远',
            far: '从远到近',
            warehouse: '按仓位',
            high: '从高到低',
            low: '从低到高',
        },
        Bottom: {
            title: '库存扣减优先规则',
            Inventory: '库存类型扣减顺序优先级',
            Drag: '拖动排序，越上面优先级越高',
            rules: '同类型虚仓扣减优先规则',
            creation: '按创建时间',
            near: '从近到远',
            far: '从远到近',
        },
        Footer: {
            title: '库存超卖限制',
            current: '当前页面数据未保存，是否直接重置？',
            Canceled: '已取消',
            total: '每个比例虚仓能连接的所有渠道仓的比例总数不超过',
            The: '*每个实仓能连接的所有比例虚仓的比例总数等于100%',
        }
    },
};
